import React from 'react';
import c from 'classnames';
import { format } from 'date-fns';

import DateSelect from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/DateSelect';

const WebformDate = (props) => {
  const { entity, ...fieldProps } = props;

  const title = entity.get('#title');
  const description = entity.get('#description');
  const key = entity.get('#webform_key');
  const required = entity.get('#required');
  const requiredError = entity.get('#required_error');

  const dateMin = parseInt(entity.get('#date_date_min')) + 1 || 1970;
  let dateMax = entity.get('#date_date_max');

  // TODO: normalize this from webformfields.
  if (dateMax === 'today') {
    dateMax = format(new Date(), 'yyyy-MM-dd');
  } else {
    dateMax = parseInt(entity.get('#date_date_max')) || 2070;
  }
  const yearMax = format(new Date(dateMax), 'yyyy');

  const wrapperClassNames = c('WebformDate', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  const labelClassNames = entity.getIn(['#label_attributes', 'class', 0], '');
  const elementClassNames = c(entity.getIn(['#attributes', 'class', 0], ''), {
    error: fieldProps.errors[key] && fieldProps.touched[key] ? 'error' : '',
  });

  return (
    <div className={wrapperClassNames}>
      <DateSelect
        {...fieldProps}
        className={elementClassNames}
        labelClassName={labelClassNames}
        title={title}
        required={required}
        requiredError={requiredError}
        description={description}
        fieldName={key}
        touched={props.touched[key]}
        error={props.errors[key]}
        value={props.values[key]}
        yearMin={dateMin}
        yearMax={yearMax}
        maxDate={dateMax}
      />
    </div>
  );
};

export default WebformDate;
